export * from './bundle.ts'

// Core
export type { UppyOptions, UIPluginOptions } from '@uppy/core'

// UI plugins
export type { DashboardOptions } from '@uppy/dashboard'
export type { DragDropOptions } from '@uppy/drag-drop'
export type { DropTargetOptions } from '@uppy/drop-target'
export type { FileInputOptions } from '@uppy/file-input'
export type { ImageEditorOptions } from '@uppy/image-editor'
export type { InformerOptions } from '@uppy/informer'
export type { ProgressBarOptions } from '@uppy/progress-bar'
export type { StatusBarOptions } from '@uppy/status-bar'

// Acquirers
export type { AudioOptions } from '@uppy/audio'
export type { BoxOptions } from '@uppy/box'
export type { DropboxOptions } from '@uppy/dropbox'
export type { FacebookOptions } from '@uppy/facebook'
export type { GoogleDriveOptions } from '@uppy/google-drive'
export type { GooglePhotosOptions } from '@uppy/google-photos'
export type { InstagramOptions } from '@uppy/instagram'
export type { OneDriveOptions } from '@uppy/onedrive'
export type { RemoteSourcesOptions } from '@uppy/remote-sources'
export type { ScreenCaptureOptions } from '@uppy/screen-capture'
export type { UnsplashOptions } from '@uppy/unsplash'
export type { UrlOptions } from '@uppy/url'
export type { WebcamOptions } from '@uppy/webcam'
export type { ZoomOptions } from '@uppy/zoom'

// Uploaders
export type { AwsS3Options } from '@uppy/aws-s3'
export type { TransloaditOptions } from '@uppy/transloadit'
export type { TusOptions } from '@uppy/tus'
export type { XHRUploadOptions } from '@uppy/xhr-upload'

// Miscellaneous
export type { CompressorOptions } from '@uppy/compressor'
export type { FormOptions } from '@uppy/form'
export type { GoldenRetrieverOptions } from '@uppy/golden-retriever'
export type { ThumbnailGeneratorOptions } from '@uppy/thumbnail-generator'
